import { Box } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import Testimonial from '../Testimonial/Testimonial';

import {
  testimonialsGridSx,
  testimonialsHeadSx,
  testimonialsInnerSx,
  testimonialsSectionSx,
} from '../../homeSsrStyles';

import albert from './images/albert.jpg';
import gabriel from './images/gabriel.jpg';
import miguel from './images/miguel.jpg';
import albert140 from './images/albert140.jpg';
import gabriel140 from './images/gabriel140.jpg';
import miguel140 from './images/miguel140.jpg';

const messages = defineMessages({
  t1Comment: {
    id: 'Testimonials.T1.Comment',
    defaultMessage: "The easiest way to capture our customer's satisfaction over time.",
  },
  t2Comment: {
    id: 'Testimonials.T2.Comment',
    defaultMessage: 'A product that does what it says in the easiest and cheapest manner.',
  },
  t3Comment: {
    id: 'Testimonials.T3.Comment',
    defaultMessage: "We have consistently improved our product with Promoter Ninja's feedback.",
  },
});

function Testimonials(props) {
  const { formatMessage } = props.intl;

  return (
    <Box component="section" sx={testimonialsSectionSx}>
      <Box sx={testimonialsInnerSx}>
        <Box component="h1" sx={testimonialsHeadSx}>
          <FormattedMessage id="Testimonials.Title" defaultMessage="What our customers say" />
        </Box>
        <Box sx={testimonialsGridSx}>
          <Testimonial
            author="Miguel Fresneda"
            pic={miguel}
            pic2x={miguel140}
            width={70}
            company="Woffu"
            comment={formatMessage(messages.t1Comment)}
          />
          <Testimonial
            author="Albert Armengol"
            pic={albert}
            pic2x={albert140}
            width={70}
            company="Docplanner"
            comment={formatMessage(messages.t2Comment)}
          />
          <Testimonial
            author="Gabriel Prat"
            pic={gabriel}
            pic2x={gabriel140}
            width={70}
            company="Hoshinplan"
            comment={formatMessage(messages.t3Comment)}
          />
        </Box>
      </Box>
    </Box>
  );
}

Testimonials.defaultProps = {
  intl: null,
};

Testimonials.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default injectIntl(Testimonials);
